import { useEffect, useState } from "react";
import { ICampusSafetyAlert } from "../../../../models/common/INavbar";
import { connect, useDispatch } from "react-redux";
import ReactModal from "react-modal";
import ContactTeamModal from "../../../../common-components/contactTeamModal";
import { setSafetyAlert } from "../../../../store/slices/common/campusSafetyAlertSlice";
import { getCampusSafetyAlertDetail } from "../../../../action/common/campusSafetyAlertActionCreator";
import { apiConfig } from "../../../../constants/apiConfig";

const StaffCampusSafetyAlert = (props: ICampusSafetyAlert) => {
  const { getSafetyAlerts, safetyAlert, setCount } = props;
  const dispatch = useDispatch();
  const [showContactTeam, setShowContactTeam] = useState(false);
  const handleOpenModal = () => setShowContactTeam(true);
  const handleCloseModal = () => setShowContactTeam(false);

  const campusSafetyUrl = apiConfig.campusSafetyAlertUrl

  const handleViewMore = () => {
    window.open(campusSafetyUrl);
  };

  useEffect(() => {
    getSafetyAlerts();
  }, []);

  useEffect(() => {
    setCount(safetyAlert?.totalCount);
  }, [safetyAlert?.totalCount]);

  useEffect(() => {
    return () => {
      dispatch(setSafetyAlert([]));
    };
  }, []);

  return (
    <>
      <div className="card-wrap">
        <h2 className="mb-3">Campus Safety Alerts</h2>
        <ul className="transactions-wrap m-0">
          {safetyAlert && safetyAlert?.alerts?.length > 0 ? (
            safetyAlert.alerts.map((alert, index) => (
              <li key={index}>
                <div className="img img-orange">
                  <img
                    src="/assets/images/icon/warning.svg"
                    alt="Warning Icon"
                  />
                </div>
                <div className="w-100">
                  <div className="d-flex align-items-center justify-content-between mb-1">
                    <h6 className="m-0">{alert.title}</h6>
                    <p className="date">{alert.time}</p>
                  </div>
                  <p className="h-40">{alert.description}</p>
                </div>
              </li>
            ))
          ) : (
            <p>No safety alerts available.</p>
          )}
          <li>
            <div className="btn-flex w-100">
              <button
                className="btn btn-primary w-100"
                data-bs-toggle="modal"
                data-bs-target="#contactteam"
                onClick={handleOpenModal}
              >
                Contact Team
              </button>
              <button className="btn btn-secondary w-100" onClick={handleViewMore}>View More</button>
            </div>
          </li>
        </ul>
      </div>
      <ReactModal
        isOpen={showContactTeam}
        onRequestClose={handleCloseModal}
        className="react-modal-content"
        overlayClassName="react-modal-overlay"
      >
        <ContactTeamModal setShowContactTeam={handleCloseModal} />
      </ReactModal>
    </>
  );
};

const mapDispatchToProps = {
  getSafetyAlerts: () => getCampusSafetyAlertDetail(),
};

function mapStateToProps(state: any) {
  return {
    safetyAlert: state.safetyAlertDetail.safetyAlerts,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StaffCampusSafetyAlert);
